import TemplateView from "../../../TemplateView"
import GroupBlock from "./GroupBlock"
import UserItem from "./UserItem"
import GroupType from "../../../enums/GroupType"
import {extractPermissionsFromUser, getTitleOfGenerateMoneyReportsRight, getTitleOfModifyTimeTrackRight, groupUsers} from "../utils"
import {formatFML} from "../../../util/UserNameFormat"
import NonGroupBlock from "./NonGroupBlock"
import {escapeHtmlSymbols} from '../../../atUtils'

export default class UsersList extends TemplateView {
    constructor({
        onUserDelete = userId => {},
        userSubtitleGenerator = user => "",
        showPermissionIcons = false,
        getDisabledTooltipText = user => "",
        canModifyPredicate = user => true,
    }) {
        super();

        this.params = {
            userSubtitleGenerator,
            showPermissionIcons,
            getDisabledTooltipText,
            canModifyPredicate,
            onUserDelete,
        }

        this.state = {
            groupBy: null,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            isBTYEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false,
        };

        this.onStateDeeplyChanged(() => this._updateUsers());
    }

    templateHtml() {
        return "<div class='usersList components_itemGroup'></div>"
    }

    _updateUsers() {
        const mapUsersToUserItems = users => users.map(user => {
            return new UserItem({
                title: formatFML(user.firstName, user.lastName, user.middleName),
                subtitle: this.params.userSubtitleGenerator(user),
                deleteButtonVisible: this.state.canModifyAny,
                deleteButtonDisabled: !this.params.canModifyPredicate(user),
                deleteButtonDisabledTooltipText: this.params.getDisabledTooltipText(user),
                showPermissionIcons: this.params.showPermissionIcons,
                onDeleteClick: () => this.params.onUserDelete(user.id),
                showCostReports: this.state.isURAEnabled || this.state.isBTYEnabled,
                costReportsTooltipText: getTitleOfGenerateMoneyReportsRight(this.state.isBTYEnabled, this.state.isURAEnabled),
                modifyTimeTrackTooltipText: getTitleOfModifyTimeTrackRight(this.state.isTTAEnabled),
                ...extractPermissionsFromUser(user),
            })
        })

        this.$el.empty();

        if (this.state.groupBy) {
            let groups, groupIdProp;
            if (this.state.groupBy === GroupType.USER_GROUP) {
                groups = this.state.userGroups;
                groupIdProp = "userGroupId";
            } else if (this.state.groupBy === GroupType.TIME_ZONE_GROUP) {
                groups = this.state.timeZoneGroups;
                groupIdProp = "timeZoneGroupId";
            }

            const groupedUsers = groupUsers(this.state.users, groups, groupIdProp);

            groupedUsers.forEach(group => new GroupBlock(this.$el, {
                title: escapeHtmlSymbols(group.name),
                items: mapUsersToUserItems(group.users)
            }).init());
        } else {
            new NonGroupBlock(mapUsersToUserItems(this.state.users)).init(this.$el);
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/usersList/UsersList.js